import { API_URL } from '../../api/client';

const DbArchive = (): React.JSX.Element => {
   return (
      <article className="md-content__inner md-typeset">
         <h1 id="installation">AHoJ-DB Archive</h1>

         <p>Here you can download the latest and previous versions of the AHoJ-DB database.</p>

         <h2>Download</h2>

         <table id="db-downloads-table">
            <thead>
               <tr>
                  <th>Version</th>
                  <th>Release Date</th>
                  <th>Note</th>
                  <th>Stats</th>
                  <th>Download</th>
               </tr>
            </thead>
            <tbody>
               <tr>
                  <td>v2c (latest)</td>
                  <td>2025-04-03</td>
                  <td>Contains additional 6847 entries compared to v2b.</td>
                  <td>
                     <a href={`${API_URL}/api/db/archive/v2c/db_stats.json`}>stats.json</a>
                  </td>
                  <td>
                     <a href={`${API_URL}/api/db/archive/download/ahojdb_v2c.tar.gz`}>ahojdb_v2c.tar.gz</a> (38GB)
                  </td>
               </tr>
               <tr>
                  <td>v2b</td>
                  <td>2024-09-15</td>
                  <td>Second publicly released version.</td>
                  <td>
                     <a href={`${API_URL}/api/db/archive/v2b/db_stats.json`}>stats.json</a>
                  </td>
                  <td>
                     <a href={`${API_URL}/api/db/archive/download/ahojdb_v2b.tar.gz`}>ahojdb_v2b.tar.gz</a> (38GB)
                  </td>
               </tr>
               <tr>
                  <td>v1</td>
                  <td>2023-07-22</td>
                  <td>First publicly released version.</td>
                  <td>
                     <a href={`${API_URL}/api/db/archive/v1/db_stats.json`}>stats.json</a>
                  </td>
                  <td>
                     <a href={`${API_URL}/api/db/archive/download/ahojdb_v1.tar.gz`}>ahojdb_v1.tar.gz</a> (28GB)
                  </td>
               </tr>
               <tr>
                  <td>Subset 1 (v1)</td>
                  <td>2024-01-31</td>
                  <td>List of entries in Subset 1 (AHoJ-DB publication).</td>
                  <td></td>
                  <td>
                     <a
                        href={`${API_URL}/api/db/archive/download/v1/parsing_v6a1_647batches_517442jobs_100mpdrsd_4.5res.zip`}
                     >
                        parsing_v6a1_647batches_517442jobs_100mpdrsd_4.5res.zip
                     </a>{' '}
                     (5.46MB)
                  </td>
               </tr>
               <tr>
                  <td>Subset 2 (v1)</td>
                  <td>2024-01-31</td>
                  <td>List of entries in Subset 2 (AHoJ-DB publication).</td>
                  <td></td>
                  <td>
                     <a
                        href={`${API_URL}/api/db/archive/download/v1/parsing_v6a1_647batches_517442jobs_100mpdrsd_4.5res_1fullpockets.zip`}
                     >
                        parsing_v6a1_647batches_517442jobs_100mpdrsd_4.5res_1fullpockets.zip
                     </a>{' '}
                     (5.48MB)
                  </td>
               </tr>
            </tbody>
         </table>
      </article>
   );
};

export default DbArchive;
